import { WarningCircle } from '@phosphor-icons/react';
import { createSlice, isRejected } from '@reduxjs/toolkit';
import React from 'react';
import { v4 as uuidV4 } from 'uuid';

const INITITAL_STATE = {
  items: []
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: INITITAL_STATE,
  reducers: {
    add: (state, action) => {
      state.items = state.items
        .filter((i) => i.id !== action.payload?.id)
        .concat({
          ...action.payload,
          id: action.payload?.id || uuidV4()
        });
    },
    remove: (state, action) => {
      const ids = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      state.items = state.items.filter((i) => ids.indexOf(i.id) == -1);
    },
    clear: (state, action) => {
      state.items = INITITAL_STATE.items;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(isRejected, (state, action) => {
      if (action.payload?.notify === false) {
        return;
      }
      const actionLabel = action?.type?.split('/')?.[0] || null;
      const message =
        action.payload?.message ||
        action.payload?.errors?.message ||
        action.payload?.key ||
        action.payload;

      if (message && !state.items.find((i) => i.title === message)) {
        const content = {
          id: action.payload?.key || actionLabel || uuidV4(),
          content: message || 'server.error',
          localize: true,
          icon: <WarningCircle className='text-danger fs-1' />
        };

        state.items = state.items
          .filter((i) => i.id !== content?.id)
          .concat(content);
      }
    });
  }
});

export default notificationSlice.reducer;
export const { add, remove, clear } = notificationSlice.actions;
